window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.casinoKomponenteRepo = (function () {
    var url = "api/casinokomponente?c=" + casino.config.guiCacheVerzija;

    var get = function () {
        return fetch(url)
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    };
})();
